/* Keep header dropdowns inside the viewport.
   Each panel is anchored to its own menu item (CSS); on hover/focus this shifts it
   sideways only as far as needed so it never crosses a screen edge. */
(function () {
  var GUTTER = 12;

  function place(li) {
    var panel = li.querySelector(':scope > ul.sub-menu');
    if (!panel || window.innerWidth < 992) return;

    panel.style.removeProperty('left');
    panel.style.removeProperty('right');

    var liRect = li.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();
    var width = panelRect.width;
    var vw = document.documentElement.clientWidth;

    // offset of the panel's left edge from the menu item's left edge
    var offset = panelRect.left - liRect.left;
    var left = liRect.left + offset;

    if (left + width > vw - GUTTER) left = vw - GUTTER - width;
    if (left < GUTTER) left = GUTTER;

    panel.style.setProperty('left', left - liRect.left + 'px', 'important');
    panel.style.setProperty('right', 'auto', 'important');
  }

  function init() {
    var items = document.querySelectorAll('nav.site-nav > ul > li.menu-item-has-children');
    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () { place(li); });
      li.addEventListener('focusin', function () { place(li); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
